module.exports = __webpack_public_path__ + "static/media/icon-pill-platform-tennis.031f1eb4.svg";